import React from "react";

export default function SectionHeader({
  title,
  subtitle,
  chips = [],
  action = null,
}) {
  return (
    <div className="section-header">
      <div className="section-header-left">
        <h3 className="section-header-title">{title}</h3>
        {subtitle ? (
          <p className="section-header-subtitle">{subtitle}</p>
        ) : null}
      </div>

      <div className="section-header-right">
        {chips.length > 0 && (
          <div className="section-header-chips">
            {chips.map((chip, index) => (
              <div key={index} className="section-header-chip">
                {chip}
              </div>
            ))}
          </div>
        )}

        {action ? <div>{action}</div> : null}
      </div>
    </div>
  );
}
